import React from 'react'
import lang from '@/lang'

const HeaderEmpty = ({ onClick }) => {
  return (
    <div className='headerEmpty' onClick={onClick}>
      <div className='headerEmpty_title'><b>LOGO</b>HIER</div>
      <span className='headerEmpty_subtitle'>{lang.tenantLogoSettings.logo.selectUpload + lang.tenantLogoSettings.logo.selectUploadSpecial }</span>
    </div>
  )
}

export default HeaderEmpty
